import React, { PureComponent } from "react";
import ReactDOM from "react-dom";

import Editor from "react-medium-editor";
import Colors from "../constants/Colors";
import withStyles from "@material-ui/core/styles/withStyles";

// load theme styles with webpack
require("medium-editor/dist/css/medium-editor.css");
require("medium-editor/dist/css/themes/default.css");

const styles = theme => ({
  textEditor: {
    color: "#3A4554",
    cursor: "text",
    fontSize: "1rem",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    lineHeight: "1.1875em",
    // height: "19px",
    // marginTop: 16,
    // marginBottom: 8,
    // border: "none",
    outline: "none",
    // boxSizing: "border-box",
    background: "transparent",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "4px",
    padding: "14px 14px",
    verticalAlign: "center",
    width: "100%",
    maxWidth: "40vw",
    transition: "all .2s ease",
    "&:hover": {
      borderColor: "rgba(0, 0, 0, 1)"
    },
    "&:focus": {
      borderColor: Colors.main,
      borderWidth: 2
    }
  },

  editorDiv: {
    // borderColor: "rgba(0, 0, 0, 0.23)",
    // borderStyle: "solid",
    // borderWidth: "1px",
    // borderRadius: "4px",
    // padding: "18.5px 14px",
    width: "100%"
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center"
    // borderStyle: "solid",
    // borderWidth: "1px",
    // borderRadius: "4px",
    // padding: "18.5px 14px",
    // boxSizing: "border-box"
  },
  label: {
    position: "absolute",
    top: "16px",
    left: 0,
    fontSize: "16px",
    color: "#9098A9",
    fontWeight: 500,
    transformOrigin: "0 0",
    transition: "all .2s ease"
  }
});

const EditableInput = ({ classes, text, onChange, placeholder }) => {
  return (
    <Editor
      data-placeholder={!text ? placeholder : " "}
      //   placeholder={{ text: "Titre de l'Action" }}
      className={classes.textEditor}
      // tag="pre"
      text={text}
      onChange={onChange}
      options={{
        toolbar: { buttons: ["bold", "italic", "underline"] }
      }}
    />
  );
};

export default withStyles(styles)(EditableInput);
